module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_5012.dc17041f.png";